/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { GA4_EVENT_SELECT_ITEM, PAGE_DATA_LAYER } from '@/data/constants/gtm';
import { getGTMCarouselProductClickEventData } from '@/data/events/data/gtm/CarouselProductClick';
import { getGTMConfig } from '@/data/events/handlers/gtm';
import { GTMCarouselProductClickPayload } from '@/data/types/GTM';
import { error as logError } from '@/data/utils/loggerUtil';
import TagManager from 'react-gtm-module';

export const measure_GA4 = async (
	data: Awaited<ReturnType<typeof getGTMCarouselProductClickEventData>>
) => {
	const dataLayerName = PAGE_DATA_LAYER;

	TagManager.dataLayer({
		dataLayer: { ecommerce: null },
		dataLayerName,
	});

	TagManager.dataLayer({
		dataLayer: {
			event: GA4_EVENT_SELECT_ITEM,
			...data,
		},
		dataLayerName,
	});
};

export const sendGTMCarouselProductClickEvent = async (
	payload: GTMCarouselProductClickPayload
) => {
	const { ga4 } = getGTMConfig(payload.settings);

	if (ga4) {
		const data = await getGTMCarouselProductClickEventData(payload);
		try {
			await measure_GA4(data);
		} catch (error) {
			logError(
				undefined,
				'CarouselProductClick: sendGTMCarouselProductClickEvent: measure_GA4: error: %o',
				error
			);
		}
	}
};
